function padWithZero(value: number): string {
  return String(value).padStart(2, '0');
}

export function getRemainingTime(endTime: Date): string {
  const endDate = new Date(endTime);
  const now = new Date();

  const timeDifference = Math.max(endDate.getTime() - now.getTime(), 0);

  const days = Math.floor(timeDifference / (24 * 3600000));
  const hours = padWithZero(Math.floor((timeDifference % (24 * 3600000)) / 3600000));
  const minutes = padWithZero(Math.floor((timeDifference % 3600000) / 60000));
  const seconds = padWithZero(Math.floor((timeDifference % 60000) / 1000));

  const daysString = days > 0 ? `${days}d ` : '';

  return `${daysString}${hours}:${minutes}:${seconds}`;
}
